import script from "./BenefitshowPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenefitshowPage.vue?vue&type=script&setup=true&lang=ts"

import "./BenefitshowPage.vue?vue&type=style&index=0&id=d74a27ae&lang=scss"

const __exports__ = script;

export default __exports__